// extracted by mini-css-extract-plugin
export default {"targetList":"TargetList_targetList__A8h5R"};